// Responsive helpers. We pick a single breakpoint (720px) below which the
// terminal layout collapses from "rail + main" two-column to "main on top,
// rail below", and trims toolbar/footer chrome that's keyboard-only or too
// dense for narrow screens.

import { useEffect, useState } from "react";

export const NARROW_BREAKPOINT_PX = 720;

export function useIsNarrow(threshold: number = NARROW_BREAKPOINT_PX): boolean {
  const [narrow, setNarrow] = useState<boolean>(() =>
    typeof window === "undefined" ? false : window.innerWidth < threshold,
  );
  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth < threshold);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [threshold]);
  return narrow;
}
